module.exports = __webpack_public_path__ + "img/card-bg3.27ee72e3.png";